import "./style.scss";
import { useTranslation } from "react-i18next";
import { setCookie, setLocalStorage } from "../../utils/general";

function Main() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang) => {
    const currentLang = localStorage.getItem("locale");

    if (currentLang === lang) return;

    setCookie("locale", lang);
    setLocalStorage("locale", lang);

    i18n.changeLanguage(lang);
  };

  const handleOpenNewTab = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="main">
      <div className="main__language">
        <div className="main__language__logo">
          <img
            alt=""
            src={`${process.env.PUBLIC_URL}/assets/img/langs_icn.svg`}
          />
        </div>
        <div
          className="main__language__english"
          onClick={() => changeLanguage("en")}
        >
          <b>ENG</b>
        </div>
        <div className="main__language__divider"></div>
        <div
          className="main__language__chinese"
          onClick={() => changeLanguage("cn")}
        >
          中文
        </div>
      </div>

      <section className="main__top">
        <div className="main__top__bg-img">
          <img
            alt=""
            src={`${process.env.PUBLIC_URL}/assets/img/group_227.jpg`}
          />
        </div>
        <div className="main__top__content">
          <div className="main__top__content__logo">
            <img
              alt=""
              src={`${process.env.PUBLIC_URL}/assets/img/dq_logo_2.svg`}
            />
          </div>
          <div className="main__top__content__sentence">{t("1")}</div>
        </div>
      </section>

      <section className="main__details">
        <div className="main__details__bg-img">
          <img
            alt=""
            src={`${process.env.PUBLIC_URL}/assets/img/mask_group_1.png`}
          />
        </div>
        <div className="main__details__content">
          <div className="main__details__content__title">{t("2")}</div>
          <div className="main__details__content__info">
            <div>
              <div className="info-icon">
                <img
                  alt=""
                  src={`${process.env.PUBLIC_URL}/assets/img/icon_ionic_ios_calendar.svg`}
                />
              </div>
              <div className="info-description">{t("3")}</div>
            </div>
            <div>
              <div className="info-icon">
                <img
                  alt=""
                  src={`${process.env.PUBLIC_URL}/assets/img/icon_awesome_clock.svg`}
                />
              </div>
              <div className="info-description">{t("4")}</div>
            </div>
            <div>
              <div className="info-icon">
                <img
                  alt=""
                  src={`${process.env.PUBLIC_URL}/assets/img/icon_material_place.svg`}
                />
              </div>
              <div className="info-description">
                {`Grand Ballroom (Level 3)\nSt. Regis, Kuala Lumpur`}
              </div>
            </div>
            <div className="map">
              <div
                onClick={() =>
                  handleOpenNewTab("https://waze.com/ul/hw283cgp0h")
                }
              >
                <div className="map-icon">
                  <img
                    alt=""
                    src={`${process.env.PUBLIC_URL}/assets/img/icon_awesome_waze.svg`}
                  />
                </div>
                <div className="map-description">Waze</div>
              </div>
              <div
                onClick={() =>
                  handleOpenNewTab("https://maps.app.goo.gl/kfZJMCw3ZvcreCcM9")
                }
              >
                <div className="map-icon">
                  <img
                    alt=""
                    src={`${process.env.PUBLIC_URL}/assets/img/group_223.svg`}
                  />
                </div>
                <div className="map-description">Google Map</div>
              </div>
            </div>
          </div>
          <div className="main__details__content__scroll">
            <img
              alt=""
              src={`${process.env.PUBLIC_URL}/assets/img/group_216.svg`}
            />
          </div>
          <div
            className="main__details__content__rsvp"
            onClick={() => handleOpenNewTab("https://wa.link/5cyzws")}
          >
            <div className="info-icon">
              <img
                alt=""
                src={`${process.env.PUBLIC_URL}/assets/img/icon_ionic_logo_whatsapp.svg`}
              />
            </div>
            <div className="info-description">{t("5")}</div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Main;
